import React, { useState, createContext, SetStateAction, Dispatch, useContext } from "react";

export interface FilterInterface {
    q: string;
    page_size: number;
    sort_by: string;
    start_year: number;
    end_year: number;
}
const today = new Date();
const year = today.getFullYear()
const FilterContext = createContext({
    filter: {
        page_size: 20,
        start_year: 1887,
        end_year: year
    } as Partial<FilterInterface>,
    setFilter: {} as Dispatch<SetStateAction<Partial<FilterInterface>>>,
});
const FilterStateProvider = ({
    children,
    value = {} as FilterInterface,
}: {
    children: React.ReactNode;
    value?: Partial<FilterInterface>;
}) => {
    const [filter, setFilter] = useState(value);
    return (
        <FilterContext.Provider value={{ filter, setFilter }}>
            {children}
        </FilterContext.Provider>
    );
}

const useFilter = () => {
    const context = useContext(FilterContext);
    if (!context) {
        throw new Error("useFilter must be used within FilterContext");
    }
    return context;
};

export { FilterStateProvider, useFilter };
